import React, { useEffect, useState } from 'react';
import { Avatar as AntdAvatar } from 'antd';
import classNames from 'classnames';

import ImageAvatarDefault from '@/assets/images/image-avatar-default.png';
import ImageDefault from '@/assets/images/image-placeholder.png';

import { TAvatarProps } from './Avatar.types';
import './Avatar.scss';

const Avatar: React.FC<TAvatarProps> = ({ image, shape, size, text, className, defaultImage, style }) => {
  const [isError, setIsError] = useState(false);
  const defaultImagePlaceholder = defaultImage ? ImageDefault : ImageAvatarDefault;
  const isShowText = typeof text !== 'undefined';

  useEffect(() => {
    setIsError(false);
  }, [image]);

  return (
    <div className={classNames('Avatar', className)}>
      <AntdAvatar
        size={size}
        shape={shape}
        src={isError ? defaultImagePlaceholder : image || (isShowText ? undefined : defaultImagePlaceholder)}
        style={style}
        onError={(): boolean => {
          setIsError(true);
          return true;
        }}
      >
        {text}
      </AntdAvatar>
    </div>
  );
};

export default Avatar;
